export class NyukyoshaFindConditionViewModel {
    nyukyokeiyakuNo = null;
    userName = "";
    nyukyoshaName = "";
    jokyoKb = null;
    buknCd = null;
    buknName = "";
    unconfirmedFlag = false;
    userCd = null;
    /** 検索ボタン押下フラグ */
    isSearch = false;
    clear() {
        this.userCd = null;
        this.nyukyokeiyakuNo = null;
        this.userName = "";
        this.nyukyoshaName = "";
        this.jokyoKb = null;
        this.buknCd = null;
        this.buknName = "";
        this.unconfirmedFlag = false;
        this.isSearch = false;
    }
    copyFrom(condition) {
        this.userCd = condition.userCd;
        this.nyukyokeiyakuNo = condition.nyukyokeiyakuNo;
        this.userName = condition.userName;
        this.nyukyoshaName = condition.nyukyoshaName;
        this.jokyoKb = condition.jokyoKb;
        this.buknCd = condition.buknCd;
        this.buknName = condition.buknName;
        this.unconfirmedFlag = condition.unconfirmedFlag;
        this.isSearch = condition.isSearch;
    }
    get summary() {
        let txt = "";
        const getDelimiter = function (text) {
            return text.length === 0 ? "" : "、 ";
        };
        if (this.userCd) {
            txt += getDelimiter(txt);
            txt += ` 契約者コード:${this.userCd}`;
        }
        if (this.userName) {
            txt += getDelimiter(txt);
            txt += `契約者名:${this.userName}`;
        }
        if (this.nyukyokeiyakuNo) {
            txt += getDelimiter(txt);
            txt += ` 入居契約No.:${this.nyukyokeiyakuNo}`;
        }
        if (this.nyukyoshaName) {
            txt += getDelimiter(txt);
            txt += `入居者名:${this.nyukyoshaName}`;
        }
        if (this.jokyoKb) {
            txt += getDelimiter(txt);
            txt += `入居状況:${this.jokyoKb.label}`;
        }
        if (this.buknCd) {
            txt += getDelimiter(txt);
            txt += `物件コード:${this.buknCd}`;
        }
        if (this.buknName) {
            txt += getDelimiter(txt);
            txt += `物件名:${this.buknName}`;
        }
        if (this.unconfirmedFlag) {
            txt += getDelimiter(txt);
            txt += " 身上書情報未確認のみ";
        }
        return txt === "" ? "検索条件" : txt;
    }
}
